<template>
    <div class="relative w-40">
        <span
            class="flex items-center font-medium text-display text-gray-500 ml-7 cursor-pointer"
            v-on:click="isOpen = !isOpen"
        >

            Award Years
            <svg xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 40 40"
                class="w-3 h-3 ml-2 stroke-current inline text-gray-100"
                >
                <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                    <path  d="M12,19.5c-0.7,0-1.3-0.3-1.7-0.8L0.4,7.6C-0.2,6.8-0.1,5.6,0.7,5c0.8-0.6,1.9-0.6,2.5,0.2l8.6,9.8c0.1,0.1,0.2,0.1,0.4,0c0,0,0,0,0,0l8.6-9.8c0.7-0.8,1.8-0.9,2.6-0.2s0.9,1.8,0.2,2.6c0,0,0,0-0.1,0.1l-9.8,11.1C13.3,19.2,12.6,19.5,12,19.5z"></path>
                </g>
            </svg>
        </span>

        <div v-cloak v-if="isOpen"
            class="absolute top-8 left-5 z-50 w-full rounded shadow-md p-2.5 bg-white"
        >
            <ul>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2026">2026</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2025">2025</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2024">2024</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2023">2023</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2022">2022</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2021">2021</a>
                </li>
                <li class="py-1.5 border-b border-gray-500">
                    <a class="text-gray-500" href="/2020">2020</a>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
        }
    }
}

</script>

